import onDOMContentLoaded from "../../base/util/dom/onDOMContentLoaded";
import Shariff = require("shariff");

onDOMContentLoaded(() => {
    document.querySelectorAll('.as__shariff').forEach((shariffElement) => {
        new Shariff(shariffElement, {
            services: 'twitter,facebook,xing',
            orientation: 'horizontal',
            buttonStyle: 'icon'
        });
    });
});